// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ArrowLeft from "@insite/mobius/Icons/ArrowLeft";
import { pageTitleStyles } from "@steiner/Overrides/Widgets/Basic/PageTitle";
import { createLinkIconStyles } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

pageTitleStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
pageTitleStyles.goBackLink = {
    ...createLinkIconStyles({
        icon: ArrowLeft,
        linkStyles: {
            typographyProps: {
                size: 16,
            },
            icon: {
                iconProps: {
                    size: 16,
                    css: css`
                        &,
                        svg {
                            width: 14px;
                            height: 16px;
                        }
                    `,
                },
                position: "left",
            },
            css: css`
                margin-bottom: 12px;
            `,
        },
    }),
};

pageTitleStyles.title = {
    css: css`
        @media print {
            margin-bottom: 0;
        }
    `,
}